import React from 'react';
import Footer from '../../components/Layout/Footer';
import Header from '../../components/Layout/Header/Header';

export default function About() {
  return (
    <div className="template-index index-demo4">
      <div className="page-wrapper">
        <div className="classic-topHeader">
          <Header />
          <div id="page-content" className="mb-0">
            <div className="container mt-5 mb-5" style={{ minHeight: '50vh' }}>
              <h1 className="text-center mb-4">ABOUT US</h1>
              <div className="policy-content" style={{ maxWidth: '800px', margin: '0 auto', lineHeight: '1.8' }}>
                <p className="text-center mb-4">
                  Welcome to <strong>Adcaster</strong>, your trusted camera and equipment rental shop.
                </p>
                <div className="contact-details p-4 bg-light rounded">
                  <h4 className="mb-3 border-bottom pb-2">Our Details</h4>
                  <p className="d-flex mb-2">
                    <b className="me-2" style={{width: "130px", flexShrink: 0}}>Contact Person:</b> <span>Noushad Thadathil</span>
                  </p>
                  <p className="d-flex mb-2">
                    <b className="me-2" style={{width: "130px", flexShrink: 0}}>Address:</b> 
                    <span>
                      Mini Road Changuvetty, Kottakkal, Malappuram
                    </span>
                  </p>
                  <p className="d-flex mb-2">
                    <b className="me-2" style={{width: "130px", flexShrink: 0}}>Phone:</b> <span>(+91) 8078099472</span>
                  </p>
                  <p className="d-flex mb-2">
                    <b className="me-2" style={{width: "130px", flexShrink: 0}}>Email:</b> <span>adcasterkottakkal@gmail.com</span>
                  </p>
                  <p className="d-flex mb-0">
                    <b className="me-2" style={{width: "130px", flexShrink: 0}}>Working Hours:</b>
                    <span>
                      Mon - Sun / 9:00 AM - 8:00 PM
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}
